import React, { Component } from 'react';
import ReactHighcharts from '../CommonComponents/Highcharts';
export default class MonteCarloChartView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: null,
    };
  }

  style(color) {
    return {
      background: color,
    };
  }

  render() {
    const {
      clientId,
      chartData,
      isPrint,
      expanded,
      showDetails,
      breakdownArray,
      index,
      firstYear,
      lastYear,
      year,
      toggleExpanded,
      navigateYears,
      toggleShowDetails,
      isCanadian,
    } = this.props;

    const LEGEND = [
      ...(isCanadian ? [] : ['Social Security']),
      'Pension',
      'Annuities',
      'Distributions',
      'Other Incomes',
    ];

    if (!chartData) {
      return null;
    }
    return (
      <section
        className={`RetirementIncomeChart${isPrint ? ' is-print' : ''}${
          expanded ? ' expanded' : ''
        }`}
      >
        <h4>Retirement Income</h4>
        {isPrint && (
          <ul className="legend">
            {LEGEND.map((item, index) => (
              <li>
                <i style={this.style(ADV.settings.retirement_income_colors[index])}></i>
                {item}
              </li>
            ))}
          </ul>
        )}
        <div className="flex-wrap">
          <div className="chart_container">
            <ReactHighcharts
              autoResize={true}
              container="RetirementIncomeBarChartContainer"
              options={chartData}
            />
          </div>
          <div className="breakdown_detail">
            <div className="pull_tab" onClick={toggleExpanded(expanded, clientId)}>
              <i className="fa fa-sign-out-alt"></i>
            </div>
            <div className="wrapper">
              <div className={`content${showDetails ? ' detail_shown' : ''}`}>
                <h3>
                  Monthly Income Detail <span>{year}</span>
                </h3>
                <div className="controls">
                  <a
                    className={`btn prev${firstYear ? ' hide' : ''}`}
                    onClick={navigateYears(index, -1, clientId)}
                  ></a>
                  <a
                    className={`btn next${lastYear ? ' hide' : ''}`}
                    onClick={navigateYears(index, 1, clientId)}
                  ></a>
                </div>
                <a className="show_detail" onClick={toggleShowDetails(showDetails, clientId)}>
                  {showDetails ? 'Hide Detail' : 'Show Detail'}
                </a>
                <ul>
                  {breakdownArray.map(breakdown => {
                    return (
                      <li className={breakdown.classes}>
                        <i></i>
                        {breakdown.name}
                        <span className="amount">{breakdown.amount}</span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
